import 'react-native-gesture-handler';

import React from 'react';
import {useDispatch} from 'react-redux';

import AppIntroSwiper from 'src/LandingPage/AppIntroSwiper';
import AppLoadingPage from 'src/LandingPage/AppLoadingPage';
import {AppEventsLogger} from 'src/Modules/Native/Facebook';
import DrawerMenu from 'src/Nav/DrawerMenu';

//////// navigation && notifications handler component
import {NavigationContainer} from '@react-navigation/native';

import {SafeAreaProvider} from 'react-native-safe-area-context';

import {Platform, View} from 'react-native';

import {createDrawerNavigator} from '@react-navigation/drawer';
//////////////////////////
//////// utils && actions
import {setCurrentScreen} from 'src/Redux/reducers/current_screen.reducer';
import {analytics} from 'src/Utils/db';
import LoginModal from '../LandingPage/LoginModal';
import {getReduxState} from '../Utils/helpers';
import {getActiveRouteName, navigationRefSetter} from './navigationHelpers';

import LoginAdditionalInformationForm from 'src/LandingPage/LoginAdditionalInformationForm';
import LoginModalTextForm from 'src/LandingPage/LoginModalTextForm';

import {logAttributesForSentryCrashlytics} from '../Utils/fireUtils';
import {mmkvStorage} from '../Utils/mmkvStorage';

import LandingPageTabs from './LandingPageTabs';

import ScavengerHuntMainGameStack from './MainGameStack';

import {createStackNavigator} from '@react-navigation/stack';

import ReferralModal from 'src/LandingPage/ReferralModal';
import SupportModal from 'src/LandingPage/SupportModal';

import BadgeAwardModal from 'src/Badges/BadgeAwardModal';
import BadgesInfo from 'src/Badges/BadgesInfo';

import FAQ from 'src/LandingPage/FAQ';
import GrouponRedemption from 'src/LandingPage/GrouponRedemption';
import PrizeWheelModal from 'src/LandingPage/PrizeWheelModal';

import CommunityViewPhoto from 'src/LandingPage/CommunityViewPhoto';

// pull these out as globally usable, adapt review modal for barhunt as well

import QrModal from 'src/JoinRedeem/QrModal';

import EventDashboard from 'src/CustomEvents/EventDashboard';
import EventHome from 'src/CustomEvents/EventHome';

////////////////////////////////
//////////////////// backpack v2

import Backpack from 'src/Backpack/Backpack';

import PhotosModal from 'src/Backpack/PhotosModal';

import ChallengeCompletedModal from 'src/ScavengerHunt_v2/Game/ChallengeCompletedModal';

import ReportModal from 'src/ScavengerHunt_v2/Game/ReportModal';

import HelpModal from 'src/ScavengerHunt_v2/Game/HelpModal';

import HuntSocialBonuses from 'src/ScavengerHunt_v2/HuntSocialBonuses';

import JoinHuntModal from 'src/JoinRedeem/JoinHuntModal';
import PhotoVideoCamera from 'src/Modules/CommonGame/Camera/PhotoVideoCamera';
///////////////////////////////
///////////////////////////////
///////////////// classic

import ChallengeAttemptModal from 'src/ScavengerHunt_v2/Classic/ChallengeAttemptModal';
import ChallengeResultModal from 'src/ScavengerHunt_v2/Classic/ChallengeResultModal';
import LocationChallengeListModal from 'src/ScavengerHunt_v2/Classic/LocationChallengeListModal';
import NavigationChallengeModal from 'src/ScavengerHunt_v2/Classic/NavigationChallengeModal';
import NavigationChallengeScoreModal from 'src/ScavengerHunt_v2/Classic/NavigationChallengeScoreModal';

import ShareModal from 'src/Modules/ShareModal';

import QuestionFeedbackModal from 'src/Modules/QuestionFeedbackModal';

import ScavengerHuntInfoModal from 'src/Registration/ScavengerHuntInfoModal';

import SimpleStackNavigator from './SimpleStackNavigator';

import HuntMap from 'src/ScavengerHunt_v2/LegacyHuntMap';

import PlayerTrivia from 'src/ScavengerHunt_v2/Challenges/PlayerTrivia';

import AddPlayerModal from 'src/Modules/CommonGame/AddPlayerModal';
import BarChallengeCompletionModal from 'src/ScavengerHunt_v2/Challenges/BarChallenges/CompletionModal';
import HuntInfoModal from 'src/ScavengerHunt_v2/HuntInfoModal';

import CESModal from 'src/Modules/CESModal';
import ConfirmModal from 'src/Modules/ConfirmModal';

import ReviewModal from 'src/Modules/CommonGame/ReviewModal';

import LocalCreateChallengeModal from '../Local/LocalCreateChallengeModal';
import LocalCreateChallengeTypeModal from '../Local/LocalCreateChallengeTypeModal';
import LocalCreateLocationModal from '../Local/LocalCreateLocationModal';
import LocalFilterModal from '../Local/LocalFilterModal';
import LocalSiteModal from '../Local/LocalSiteModal';
import PurchaseModal from '../FoxShop/PurchaseModal';

function BackpackStack() {
  return (
    <SimpleStackNavigator
      name="BackPackStackWrapper"
      component={Backpack}
      coinsTestID={'foxShopCoins'}
    />
  );
}

function EventDashboardStack() {
  return (
    <SimpleStackNavigator
      name="EventDashboardWrapper"
      component={EventDashboard}
    />
  );
}

function EventHomeStack() {
  return <SimpleStackNavigator name="EventHomeStack" component={EventHome} />;
}

function ScavengerHuntInfoStack({route}) {
  console.log({route});
  return (
    <SimpleStackNavigator
      name="ScavengerHuntInfoStack"
      component={ScavengerHuntInfoModal}
      route={route}
    />
  );
}

function BadgesInfoStack() {
  return <SimpleStackNavigator name="BadgesInfoStack" component={BadgesInfo} />;
}

function LocalCreateLocationModalStack() {
  return (
    <SimpleStackNavigator
      name="LocalCreateLocationModalStack"
      component={LocalCreateLocationModal}
    />
  );
}
function LocalCreateChallengeModalStack() {
  return (
    <SimpleStackNavigator
      name="LocalCreateChallengeModalStack"
      component={LocalCreateChallengeModal}
    />
  );
}

const modalOptions = {unmountOnBlur: true};

const DrawerWrapper = createDrawerNavigator();

const Stack = createStackNavigator();

const RootNavigationStack = () => {
  console.log('MainAppDrawer render');
  const dispatch = useDispatch();

  const handleFacebookTracking = (currentScreen) => {
    if (Platform.OS != 'web') {
      AppEventsLogger?.logEvent?.('AppContentView', {
        content_name: currentScreen,
      });
    }
  };

  return (
    <SafeAreaProvider style={{position: 'relative'}}>
      <NavigationContainer
        // A ref to the navigation container, allowing access to the navigation object.
        ref={navigationRefSetter}
        // A callback function that is invoked whenever the navigation state changes.
        onStateChange={(currentState) => {
          // Retrieve the current screen name from the Redux state.
          const currentScreen = getReduxState([
            'current_screen',
            'currentScreen',
          ]);
          // Determine the new current screen name based on the updated navigation state.
          const newCurrentScreen = getActiveRouteName(currentState);

          console.log({newCurrentScreen});

          // Check if the new current screen is different from the previous current screen.
          if (newCurrentScreen != currentScreen) {
            // Update the Redux state with the new current screen name.
            dispatch(setCurrentScreen(newCurrentScreen));

            // Log the new current screen name as an attribute for Sentry and Crashlytics.
            logAttributesForSentryCrashlytics?.(
              'currentScreen',
              `${newCurrentScreen}`,
            );
            // and the previous screen
            logAttributesForSentryCrashlytics?.(
              'previousCurrentScreen',
              `${currentScreen || ''}`,
            );

            //tracking page in facebook
            handleFacebookTracking(newCurrentScreen);

            // saving to local state for quick access
            mmkvStorage.set('currentScreen', newCurrentScreen);

            // // Log a screen view event in Firebase Analytics with the new current screen name.
            analytics()?.logScreenView?.({
              screen_name: 'LR-APP: ' + newCurrentScreen,
              screen_class: 'LR-APP: ' + newCurrentScreen,
            });
          }
        }}>
        <DrawerWrapper.Navigator
          drawerContent={(props) => <DrawerMenu {...props} />}
          screenOptions={() => ({headerShown: 0, gestureEnabled: false})}>
          <DrawerWrapper.Screen
            name="main"
            // eslint-disable-next-line no-use-before-define
            component={RootNavigationStackContent}
          />
        </DrawerWrapper.Navigator>
      </NavigationContainer>
    </SafeAreaProvider>
  );
};

const RootNavigationStackContent = () => {
  return (
    <Stack.Navigator
      tabBar={() => <View />}
      unmountInactiveScreens
      options={{unmountOnBlur: true, headerShown: 'none'}}
      screenOptions={() => ({headerShown: 0, gestureEnabled: false})}
      drawerStyle={{width: 200}}>
      {/* white loading screen */}
      <Stack.Screen name="AppLoadingPage" component={AppLoadingPage} />

      <Stack.Screen
        name="LandingPageMain"
        component={LandingPageTabs}
        options={{unmountOnBlur: true}}
      />
      <Stack.Screen
        name="MainGameStack"
        options={{unmountOnBlur: true}}
        component={ScavengerHuntMainGameStack}
      />

      <Stack.Screen name="EventDashboard" component={EventDashboardStack} />

      <Stack.Screen name="EventHome" component={EventHomeStack} />

      {/* 3 intro pages including swiper
       */}
      <Stack.Screen name="AppIntroSwiper" component={AppIntroSwiper} />

      <Stack.Screen name="LoginPage">
        {(props = {}) => {
          return <LoginModal {...props} isFullScreen />;
        }}
      </Stack.Screen>
      <Stack.Screen name="LoginAdditionalInfoFullScreenPage">
        {(props = {}) => {
          return <LoginAdditionalInformationForm {...props} isFullScreen />;
        }}
      </Stack.Screen>

      {/* login modal and information modal,
  needed high level
*/}

      {/* 
// 
// 
// 
start of modals
https://reactnavigationRef.org/docs/stack-navigator/#presentation
// 
// 
*/}

      <Stack.Group
        // https://reactnavigationRef.org/docs/stack-navigator/#presentation
        screenOptions={{
          presentation: 'modal',
          gestureEnabled: false,

          cardStyle: {backgroundColor: global.color.black_60},
          layout: {
            backgroundColor: 'red',
          },
        }}>
        <Stack.Screen name="FoxShop" component={BackpackStack} />
      </Stack.Group>
      <Stack.Group
        // https://reactnavigationRef.org/docs/stack-navigator/#presentation
        screenOptions={{
          presentation: 'transparentModal',
          gestureEnabled: true,
          unmountOnBlur: true,

          cardStyle: {backgroundColor: global.color.black_60},
          layout: {
            backgroundColor: 'red',
          },
        }}>
        <Stack.Screen
          name="LoginModal"
          component={LoginModal}
          options={{
            modalPresentationStyle: 'overCurrentContext',
            layout: {
              backgroundColor: 'transparent',
            },
          }}
        />
        <Stack.Screen
          name="LoginModalTextForm"
          component={LoginModalTextForm}
          options={{
            modalPresentationStyle: 'overCurrentContext',
            layout: {
              backgroundColor: 'transparent',
            },
          }}
        />
        <Stack.Screen
          name="LoginAdditionalInformationForm"
          component={LoginAdditionalInformationForm}
        />

        <Stack.Screen name="PhotosModal" component={PhotosModal} />

        <Stack.Screen
          name="ScavengerHuntInfoModal"
          component={ScavengerHuntInfoStack}
        />
        <Stack.Screen
          name="ConfirmModal"
          options={modalOptions}
          component={ConfirmModal}
        />

        <Stack.Screen
          name="ReferralModal"
          options={modalOptions}
          component={ReferralModal}
        />
        <Stack.Screen
          name="BadgeAwardModal"
          options={modalOptions}
          component={BadgeAwardModal}
        />
        <Stack.Screen
          name="SupportModal"
          options={modalOptions}
          component={SupportModal}
        />
        <Stack.Screen
          name="BadgesInfoModal"
          options={modalOptions}
          component={BadgesInfoStack}
        />

        <Stack.Screen
          name="PrizeWheelModal"
          options={modalOptions}
          component={PrizeWheelModal}
        />
        <Stack.Screen
          name="ShareModal"
          options={modalOptions}
          component={ShareModal}
        />
        <Stack.Screen
          name="JoinHuntModal"
          options={modalOptions}
          component={JoinHuntModal}
        />

        <Stack.Screen
          name="CommunityViewPhoto"
          options={modalOptions}
          component={CommunityViewPhoto}
        />
        <Stack.Screen
          name="GrouponRedemption"
          options={modalOptions}
          component={GrouponRedemption}
        />
        <Stack.Screen
          name="QuestionFeedback"
          options={modalOptions}
          component={QuestionFeedbackModal}
        />
        <Stack.Screen
          name="CESModal"
          options={modalOptions}
          component={CESModal}
        />

        <Stack.Screen name="FAQ" options={modalOptions} component={FAQ} />
        <Stack.Screen
          name="PhotoVideoCamera"
          options={modalOptions}
          component={PhotoVideoCamera}
        />

        <Stack.Screen
          name="HuntSocialBonuses"
          options={modalOptions}
          component={HuntSocialBonuses}
        />

        <Stack.Screen
          name="QrModal"
          options={modalOptions}
          component={QrModal}
        />

        <Stack.Screen
          name="ChallengeCompletedModal"
          options={modalOptions}
          component={ChallengeCompletedModal}
        />

        <Stack.Screen
          name="ReportModal"
          options={modalOptions}
          component={ReportModal}
        />

        <Stack.Screen
          name="HelpModal"
          options={modalOptions}
          component={HelpModal}
        />

        <Stack.Screen
          name="NavigationChallengeModal"
          options={modalOptions}
          component={NavigationChallengeModal}
        />
        <Stack.Screen
          name="NavigationChallengeScoreModal"
          options={modalOptions}
          component={NavigationChallengeScoreModal}
        />
        <Stack.Screen
          name="ChallengeAttemptModal"
          options={modalOptions}
          component={ChallengeAttemptModal}
        />
        <Stack.Screen
          name="ChallengeResultModal"
          options={modalOptions}
          component={ChallengeResultModal}
        />
        <Stack.Screen
          name="LocationChallengeListModal"
          options={modalOptions}
          component={LocationChallengeListModal}
        />
        <Stack.Screen
          name="AddPlayerModal"
          options={modalOptions}
          component={AddPlayerModal}
        />
        <Stack.Screen
          name="HuntInfoModal"
          options={modalOptions}
          component={HuntInfoModal}
        />
        <Stack.Screen
          name="BarChallengeCompletionModal"
          options={modalOptions}
          component={BarChallengeCompletionModal}
        />
        <Stack.Screen
          name="HuntMap"
          options={modalOptions}
          component={HuntMap}
        />
        <Stack.Screen
          name="PlayerTrivia"
          options={modalOptions}
          component={PlayerTrivia}
        />
        <Stack.Screen
          name="ReviewModal"
          options={modalOptions}
          component={ReviewModal}
        />
        <Stack.Screen
          name="LocalCreateChallengeModal"
          options={modalOptions}
          component={LocalCreateChallengeModalStack}
        />

        <Stack.Screen
          name={'LocalCreateLocationModal'}
          component={LocalCreateLocationModalStack}
        />
        <Stack.Screen name={'LocalSiteModal'} component={LocalSiteModal} />
        <Stack.Screen name={'LocalFilterModal'} component={LocalFilterModal} />
        <Stack.Screen
          name={'LocalCreateChallengeTypeModal'}
          component={LocalCreateChallengeTypeModal}
        />
        <Stack.Screen name={'PurchaseModal'} component={PurchaseModal} />
      </Stack.Group>
    </Stack.Navigator>
  );
};

//eslint-disable-next-line
export default RootNavigationStack;
